'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _RequestStatus = require('pricing-pages-unified-ui/constants/RequestStatus');

var RequestStatus = _interopRequireWildcard(_RequestStatus);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  requestStatus: RequestStatus.UNINITIALIZED,
  users: null
};

var usersInPortal = function usersInPortal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes2.default.USERS_IN_PORTAL_REQUESTED:
      return { requestStatus: RequestStatus.PENDING };
    case _ActionTypes2.default.USERS_IN_PORTAL_RECEIVED:
      return {
        requestStatus: RequestStatus.SUCCEEDED,
        users: payload
      };
    case _ActionTypes2.default.USERS_IN_PORTAL_FAILED:
      return { requestStatus: RequestStatus.FAILED };
    default:
      return state;
  }
};

exports.default = usersInPortal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/UsersInPortal.js
// module id = 393
// module chunks = 3 4 5